import { parseMultiFromCsvCell } from "./commercialProjectSchema";

/** Trim CSV artifacts (quotes, whitespace) before URL validation. */
export function normalizeFileImportUrl(raw) {
  let t = String(raw ?? "").trim();
  if (!t) return "";
  if (
    (t.startsWith('"') && t.endsWith('"')) ||
    (t.startsWith("'") && t.endsWith("'"))
  ) {
    t = t.slice(1, -1).trim();
  }
  return t;
}

export function isHttpUrl(s) {
  const t = normalizeFileImportUrl(s);
  if (!t) return false;
  try {
    const u = new URL(t);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

/** One or more http(s) URLs from a CSV cell. */
export function parseFileUrlsFromCsvCell(raw) {
  const parts = parseMultiFromCsvCell(raw);
  const urls = [];
  for (const p of parts) {
    const t = normalizeFileImportUrl(p);
    if (isHttpUrl(t)) urls.push(t);
  }
  return urls;
}
